import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LandingHistoryComponent } from './landing-history.component';
import { TagTextModule } from '../tag-text/tag-text.module';


@NgModule({
    declarations: [
        LandingHistoryComponent
    ],
    exports: [
        LandingHistoryComponent
    ],
    imports: [
    CommonModule,
    TagTextModule,
    TranslateModule
]
})
export class LandingHistoryModule {
}
